import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCountryOption } from "../services/api";
import { setCountryOption } from "../store/slices/countryOption";

// Loads the country option of the funnel once per country and keeps it in the
// store. Returns the loaded option, or null while it is loading or unknown.
export const useCountryOption = () => {
  const dispatch = useDispatch();
  const country = useSelector(
    (state) => state.funnelInfo.funnel.companyInfo?.country
  );
  const countryOption = useSelector(
    (state) => state.countryOption.countryOption
  );
  const loadedKey = countryOption?.key;

  useEffect(() => {
    if (!country || loadedKey === country) return;

    const loadCountryOption = async () => {
      try {
        const response = await fetchCountryOption({ keyName: country });
        dispatch(setCountryOption(response.data.data));
      } catch (error) {
        console.error("Failed to fetch country option:", error);
      }
    };
    loadCountryOption();
  }, [country, loadedKey, dispatch]);

  return countryOption;
};
